import React from 'react'
import PropTypes from 'prop-types'
import css from 'styled-jsx/css'

const styles = css`
  span {
    display: inline-block;
    vertical-align: middle;
    position: relative;
  }

  svg {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`

const getRotation = (direction) => {
  switch (direction) {
    case 'right':
      return 0
    case 'left':
      return 180
    case 'down':
      return 0
    case 'up':
      return -90
    default:
      return 0
  }
}

const Chevron2Icon = ({
  width,
  height,
  color,
  direction,
}) => (
  <span
    data-testid="span-element"
    style={{

      width: `${width}px`,
      height: `${height}px`,
    }}
  >
    <svg
      data-testid="svg-element"
      width={width}
      height={height}
      viewBox="0 0 9 5"
      fill={color}
    >
      <path
        style={{
          transform: `rotate(${getRotation(direction)}deg)`,
          transformBox: 'fill-box',
          transformOrigin: 'center center',
        }}
        d="M4.75538 4.75595C4.42998 5.08135 3.90154 5.08135 3.57615 4.75595L0.244118 1.42392C0.00462783 1.18443 -0.0656572 0.827802 0.0645003 0.515424C0.194658 0.203046 0.496623 0 0.835033 0H7.4991C7.8349 0 8.13947 0.203046 8.26963 0.515424C8.39979 0.827802 8.3269 1.18443 8.09001 1.42392L4.75798 4.75595H4.75538Z"
      />
    </svg>
    <style jsx>{styles}</style>
  </span>
)

Chevron2Icon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
  direction: PropTypes.oneOf([
    'up',
    'down',
    'left',
    'right',
  ]),
}

Chevron2Icon.defaultProps = {
  width: 8,
  height: 5,
  color: 'currentColor',
  direction: 'right',
}

export default Chevron2Icon
